import React, { createContext, useState } from "react";
import {Product} from "@beeldit/ecommerce/products/models/Product";

interface CreateActionContextType {  
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;  
  element: Product;
  setElement: (element: any) => void;
  selectedLang: string;
  setSelectedLang: (selectedLang: string) => void;
  attributes: any[],
  setAttributes: (attributes: any) => void;

}

export const CreateActionContext = createContext<CreateActionContextType>({  
  backendFormErrors: {},
  setBackendFormErrors: () => {},
  element: new Product(),
  setElement: () => {},
  selectedLang: "",
  setSelectedLang: () => {},
  attributes: [],
  setAttributes: () => {}
});

interface CreateActionProviderProps {
  children: React.ReactNode;
}

export const CreateActionProvider: React.FC<CreateActionProviderProps> = ({
  children,
}) => {  
  const [backendFormErrors, setBackendFormErrors] = useState(null);
  const [element, setElement] = useState<any>(new Product());
  const [selectedLang, setSelectedLang] = useState<string>("");
  const [attributes, setAttributes] = useState<any[]>([]);

  const value = {    
    backendFormErrors,
    setBackendFormErrors,
    element,
    setElement,
    selectedLang,
    setSelectedLang,
    attributes,
    setAttributes
  };
  return (
    <CreateActionContext.Provider value={value}>
      {children}
    </CreateActionContext.Provider>
  );
};
